import ModalComponent from "..";
import { ModalCompProps } from "../../../utils/types";
import { Icon } from "../../icon/icon";
import { AdminProfileDetails } from "../../layout/adminAppLayout";
import { ProfileDetails } from "../../layout/appLayout";

export const MobileNavModal = ({
  open,
  handleClose,
  options,
  isAdmin,
}: ModalCompProps & {
  options: { label: string; onClick: () => void; icon: string }[];
  isAdmin?: boolean;
}) => {
  return (
    <ModalComponent
      open={open}
      handleClose={handleClose}
      className="!bg-grey-50 !p-[20px]"
      dialogClassName="!my-0"
      showHeader={false}
      mobileAnchorBottom
      closeOnOverlayClick
    >
      <div className="flex flex-col gap-1">
        {isAdmin ? <AdminProfileDetails /> : <ProfileDetails />}

        {options.map((option, idx) => {
          const key = `${idx}-${option.label}`;

          return (
            <button
              key={key}
              type="button"
              onClick={() => {
                option.onClick();
                handleClose();
              }}
              className={`flex items-center gap-2 rounded-md bg-white p-3 font-bold`}
            >
              <Icon
                svg={option.icon}
                height={20}
                width={20}
                className="text-grey-400"
              />
              {option.label}
            </button>
          );
        })}
      </div>
    </ModalComponent>
  );
};
